import { createContext, useContext, useState, ReactNode } from 'react';
import { IconData, IconPackData } from "../data/icons";

type CartItem = IconData | IconPackData;

interface CartContextType {
    isCartSideBarOpen : boolean;
    setIsCartSideBarOpen: (open: boolean) => void;
    toggleCartSidebar: () => void;
    
    cartItems: CartItem[];
    addToCart: (product: CartItem) => void;
}

const CartContext = createContext<CartContextType>(null!);

export function useCart() {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    
    return context;
}

export function CartProvider({ children }: { children: ReactNode; }) {
    const [isCartSideBarOpen, setIsCartSideBarOpen] = useState(false);
    const [cartItems, setCartItems] = useState<CartItem[]>([]);
    
    const toggleCartSidebar = () => setIsCartSideBarOpen(prev => !prev);
    
    const addToCart = (product: CartItem) => {
        setCartItems(prevItems => [...prevItems, product]);
        console.log("Items in cart?: " + product.name);
    };

    const value = {
        isCartSideBarOpen,
        setIsCartSideBarOpen,
        toggleCartSidebar,
        cartItems,
        addToCart,
    };
    
    return <CartContext.Provider value={value}>
        {children}
    </CartContext.Provider>;
}



